import { useCallback, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreate,
  useNotify,
  SimpleForm,
  Create,
  useResourceContext,
  required,
  maxLength,
  useRefresh,
  minLength,
  useTranslate,
  NumberInput,
  maxValue,
  minValue,
  number,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import RestockPlanItemForm from "./components/RestockPlanItemForm";
import CodeNumberInput from "../../common/CodeNumberInput";
import getLastDateOfPreviousMonth from "../../../utils/lastDateOfPreviousMonth";
import { useFormContext, useWatch } from "react-hook-form";

const validateNumber = [required(), minLength(8), maxLength(8)];
const validateDate = [required(), minLength(10), maxLength(10)];
const validateMonth = [required(), number(), minValue(1), maxValue(12)];
const validateYear = [required(), number()];

const CompDependOnCode = ({ source, dependOn, validation, label }) => {
  const code = useWatch({ name: dependOn });
  const { setValue } = useFormContext();
  useEffect(() => {
    if (code) {
      const splitted = code.substr(3).split("/");
      const period = {
        month: splitted[0],
        year: +splitted[1] + 2000,
      };
      setValue(source, period[source]);
    }
  }, [code]);
  return (
    <NumberInput
      variant="outlined"
      source={source}
      label={label}
      fullWidth
      validate={validation}
      readOnly
    />
  );
};

export default function RestockPlanAddDialog({ open, setOpen }) {
  const [create] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext(); // cuman nama resource
  const t = useTranslate();

  const save = useCallback(
    async (values) => {
      try {
        // RUBAH NILAI FINAL DARI STRING TYPE KE NUMBER TYPE
        for (let i = 0; i < values.restock_plan_items.length; i++) {
          values.restock_plan_items[i].final =
            +values.restock_plan_items[i].final;
        }
        // RUBAH NILAI FINAL DARI STRING TYPE KE NUMBER TYPE
        await create(
          resource,
          { data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.created", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body) {
          if (error.body && error.body.errors) {
            if (error.body.errors === "403") {
              // munculkan notifikasi erro ketika sudah approved
              notify("mine.notification.403_error", { type: "error" });
            } else {
              // The shape of the returned validation errors must match the shape of the form
              return error.body.errors;
            }
          } else if (error.status === 500) {
            notify(error.message, { type: "error" });
          }
        } else if (error.status === 500) {
          notify(error.message, { type: "error" });
        }
      }
    },
    [create]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted={false}
      fullWidth={true}
      maxWidth={false}
    >
      <Create title={" "} sx={{ "& .RaCreate-main": { mt: 0 } }}>
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>
              {t("mine.label.create") + " " + t("mine.list_title.restock_plan")}
            </DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent sx={{ alignSelf: "normal" }}>
            <CodeNumberInput
              open={open}
              dependOn="cut_off_date"
              variant="outlined"
              source="code"
              label="mine.label.code"
              fullWidth
              validate={validateNumber}
              disabled
            />
            <CompDependOnCode
              source="month"
              label="mine.label.month"
              validate={validateMonth}
              dependOn="code"
            />
            <CompDependOnCode
              source="year"
              label="mine.label.year"
              validate={validateYear}
              dependOn="code"
            />

            <MuiDatePickerInput
              variant="outlined"
              source="cut_off_date"
              fullWidth
              isRequired
              validate={validateDate}
              defaultValue={getLastDateOfPreviousMonth()}
            />

            <RestockPlanItemForm />
          </DialogContent>
        </SimpleForm>
      </Create>
    </Dialog>
  );
}
